import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Container, Row, Col } from 'reactstrap'
import { useLanguage } from '../contexts/LanguageContext'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const ImpressumPage = () => {
  const { t } = useLanguage()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div style={{ overflow: 'hidden', backgroundImage: 'url("/bg-img/MicrosoftTeams-image.webp")', width: '100%', backgroundAttachment: 'fixed' }}>
        <HelmetProvider>
          <Helmet prioritizeSeoTags>
            <title>{t('impressum.title')} - IT Junction</title>
            <meta name="description" content="Impressum - IT Junction Legal Information" />
          </Helmet>
        </HelmetProvider>

        <Header2 />

        <div className="py-5" style={{ minHeight: '100vh' }}>
          <Container>
            <Row className="mb-5">
              <Col md="12">
                <div className="text-center mb-5">
                  <h1 className="fs-ss-48 text-philos fw-700 mb-3" style={{ color: '#2F2E2A' }}>
                    {t('impressum.title')}
                  </h1>
                  <div style={{ height: '3px', width: '80px', backgroundColor: '#FE9B1F', margin: '0 auto' }}></div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md="10" lg="8">
                {/* Single Box with All Information */}
                <div className="p-4 p-md-5" style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                  
                  {/* Company Information */}
                  <div className="mb-4">
                    <h2 className="fs-ss-24 text-philos fw-700 mb-3" style={{ color: '#FE9B1F' }}>
                      {t('impressum.company')}
                    </h2>
                    <p className="fs-ss-16 text-mulish fw-500 mb-2">
                      {t('impressum.owner')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-1">
                      {t('impressum.address')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-1">
                      {t('impressum.city')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-0">
                      {t('impressum.country')}
                    </p>
                  </div>

                  {/* VAT Information */}
                  <div className="mb-4 pb-4" style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <p className="fs-ss-16 text-mulish fw-600 mb-2" style={{ color: '#2F2E2A' }}>
                      {t('impressum.vat')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-0">
                      {t('impressum.vatNumber')}
                    </p>
                  </div>

                  {/* Contact Information */}
                  <div className="mb-4 pb-4" style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <h2 className="fs-ss-24 text-philos fw-700 mb-3" style={{ color: '#FE9B1F' }}>
                      {t('impressum.contact')}
                    </h2>
                    <p className="fs-ss-16 text-mulish fw-400 mb-2">
                      {t('impressum.email')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-2">
                      {t('impressum.phone')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-0">
                      {t('impressum.mobile')}
                    </p>
                  </div>

                  {/* Responsible for Content */}
                  <div>
                    <h2 className="fs-ss-24 text-philos fw-700 mb-3" style={{ color: '#FE9B1F' }}>
                      {t('impressum.responsible')}
                    </h2>
                    <p className="fs-ss-16 text-mulish fw-500 mb-2">
                      {t('impressum.responsibleName')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-1">
                      {t('impressum.responsibleAddress')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-1">
                      {t('impressum.responsibleCity')}
                    </p>
                    <p className="fs-ss-16 text-mulish fw-400 mb-0">
                      {t('impressum.responsibleCountry')}
                    </p>
                  </div>

                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  )
}

export default ImpressumPage
